package org.solyton.solawi.bid.module.list.component

import androidx.compose.runtime.*
import org.evoleq.compose.Markup
import org.evoleq.compose.attribute.dataId
import org.evoleq.compose.conditional.When
import org.evoleq.math.Source
import org.evoleq.math.emit
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.solyton.solawi.bid.module.banking.data.internal.Currency
import org.solyton.solawi.bid.module.banking.data.internal.format
import org.solyton.solawi.bid.module.banking.data.internal.toMoney
import org.solyton.solawi.bid.module.control.tooltip.Tooltip
import org.solyton.solawi.bid.module.style.overflow.Overflow
import org.solyton.solawi.bid.module.style.overflow.overflowX
import kotlin.js.Date


data class HeaderCellStyles(
    val cellWrapperStyles: StyleScope.()->Unit = {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        fontWeight("600")
        fontSize(13.px)
        color(Color("#475569"))
        textAlign("left")
        paddingLeft(5.px)
        paddingRight(5.px)
        width(10.percent)
    },
    val cellContentStyles: StyleScope.()->Unit = {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.FlexStart)
        flexGrow(1)
    },
    val cellActionStyles: StyleScope.()->Unit = {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.FlexEnd)
        flexGrow(0)
    },
    val cellFilterStyles: StyleScope.()->Unit = {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        flexGrow(0)
    },
    val cellOrderingStyles: StyleScope.()->Unit = {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        flexGrow(0)
    }
) {
    fun  modifyCellWrapperStyles(styles: StyleScope.()->Unit): HeaderCellStyles = copy(cellWrapperStyles = {cellWrapperStyles(); styles()})
    fun  modifyCellContentStyles(styles: StyleScope.()->Unit): HeaderCellStyles = copy(cellContentStyles = {cellContentStyles(); styles()})
    fun  modifyCellActionStyles(styles: StyleScope.()->Unit): HeaderCellStyles = copy(cellActionStyles = {cellActionStyles(); styles()})
    fun  modifyCellFilterStyles(styles: StyleScope.()->Unit): HeaderCellStyles = copy(cellFilterStyles = {cellFilterStyles(); styles()})
    fun  modifyCellOrderingStyles(styles: StyleScope.()->Unit): HeaderCellStyles = copy(cellOrderingStyles = {cellOrderingStyles(); styles()})

    fun  width(width: CSSNumericValue<*>): HeaderCellStyles = modifyCellWrapperStyles {
        width(width)
    }
}

@Markup
@Composable
@Suppress("FunctionName")
fun HeaderCellWithActions(
    text: Source<String>,
    styles: HeaderCellStyles = HeaderCellStyles(),
    ordering: (@Composable () -> Unit)? = null,
    filters: (@Composable () -> Unit)? = null,
) = Div({style {
    with(styles){cellWrapperStyles()}
}}) {
    Div({style {with(styles){cellContentStyles()}}}) {
        Text(text.emit())
    }
    Div({style {with(styles){cellActionStyles()}}}) {
        When(filters != null) {
            Div({ style { with(styles) { cellFilterStyles() } } }) {
                filters!!()
            }
        }
        When(ordering != null) {
            Div({ style { with(styles) { cellOrderingStyles() } } }) {
                ordering!!()
            }
        }
    }
}



@Markup
@Composable
@Suppress("FunctionName")
fun HeaderCell(
    text: Source<String>,
    tooltip: Source<String>? = null,
    style: StyleScope.()->Unit = {}
) = HeaderCell(text.emit(),tooltip?.emit(), style)

@Markup
@Composable
@Suppress("FunctionName")
fun HeaderCell(
    text: String,
    tooltip: String? = null,
    style: StyleScope.()->Unit = {}
){
    val defaultStyles: StyleScope.()-> Unit = {
        fontWeight("600")
        fontSize(13.px)
        color(Color("#475569"))
        textAlign("left")
        paddingLeft(5.px)
        paddingRight(5.px)
        width(10.percent)
    }
    when {
        tooltip != null -> Tooltip(tooltip, wrapperStyle = {
            defaultStyles()
            style()
        }) {
            Text(text)
        }
        else -> Div({
            style {
                defaultStyles()
                style()
            }
        }){Text(text)}
    }
}

@Markup
@Composable
@Suppress("FunctionName")
fun TextCell(
    text: Source<String>,
    tooltip: String? = null,
    useTextForTooltip: Boolean = false,
    style: StyleScope.()->Unit = {
    }
) = TextCell(text.emit(), tooltip,useTextForTooltip, style)

@Markup
@Composable
@Suppress("FunctionName")
fun TextCell(
    text: String,
    tooltip: String? = null,
    useTextForTooltip: Boolean = false,
    style: StyleScope.()->Unit = {}
){
    when{
        tooltip != null || useTextForTooltip -> Tooltip({tooltip?:text}, wrapperStyle = {
            textAlign("left")
            paddingLeft(5.px)
            paddingRight(5.px)
            width(10.percent)
            style()
        }) {
            Div({
                style{
                    width(100.percent)
                    overflowX(Overflow.Hidden)
                }
            }) {
                Text(text)
            }
        }
        else -> Div({
            style {
                textAlign("left")
                paddingLeft(5.px)
                paddingRight(5.px)
                width(10.percent)
     //           textOverflow(TextOverflow.Ellipsis)
                overflowX(Overflow.Hidden)
                style()
            }
        }) { Text(text) }
    }
}

@Markup
@Composable
@Suppress("FunctionName")
fun NumberCell(
    number: Source<Number>,
    style: StyleScope.()->Unit = { }
) = NumberCell(number.emit(), style)

@Markup
@Composable
@Suppress("FunctionName")
fun NumberCell(
    number: Number,
    style: StyleScope.()->Unit = { }
){
    Div({style {
        textAlign("right")
        paddingLeft(5.px)
        paddingRight(5.px)
        width(10.percent)
        style()
    }}){Text("$number")}
}

@Markup
@Composable
@Suppress("FunctionName")
fun PriceCell(
    number: Double,
    currency: Currency = Currency.EUR,
    style: StyleScope.()->Unit = { }
) = Div({style {
    textAlign("right")
    paddingLeft(5.px)
    paddingRight(5.px)
    width(10.percent)
    style()
}}){
    val price = number.toMoney(currency).format()
    Text(price)
}

@Markup
@Composable
@Suppress("FunctionName")
fun DaysCell(
    days: Int,
    style: StyleScope.()->Unit = { }
) = Div({style {
    textAlign("right")
    paddingLeft(5.px)
    paddingRight(5.px)
    width(10.percent)
    style()
}}){
    Text("${days}d")
}


@Markup
@Composable
@Suppress("FunctionName")
fun TimeCell(
    date: Source<Date>,
    showDate: Boolean = false,
    style: StyleScope.()->Unit = { }
) = TimeCell(date.emit(), showDate, style)

@Markup
@Composable
@Suppress("FunctionName")
fun TimeCell(
    date: Date,
    showDate: Boolean = false,
    style: StyleScope.()->Unit = { }
){
    Div({style {
        textAlign("left")
        width(10.percent)
        paddingLeft(5.px)
        paddingRight(5.px)
        style()
    }}){
        when{
            showDate -> Text("${date.getFullYear()}/${(date.getMonth() +1).fix()}${date.getDay().fix()} - ${date.getHours().fix()}:${date.getMinutes().fix()}")
            else -> Text("${date.getHours().fix()}:${date.getMinutes().fix()}")
        }}
}

fun Int.fix(): String = when(this){
    in (0..9) -> "0$this"
    else -> "$this"
}

@Markup
@Composable
@Suppress("FunctionName")
fun ActionCell(
    style: StyleScope.()->Unit = {},
    actions: @Composable ()->Unit
){
    Div({style {
        textAlign("left")
        width(10.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        gap(5.px)
        style()
    }}){
        actions()
    }
}

@Markup
@Composable
@Suppress("FunctionName")
fun ActionCellItem(
    text: String,
    style: StyleScope.()->Unit = {},
    onClick: () -> Unit = {},
    action: @Composable ()->Unit
){
    Div({
        onClick { onClick() }
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Row)
            gap(5.px)
        }
    }) {
        Div({
            style {
                textAlign("left")
                style()
            }
        }) {
            Text(text)
        }
        action()
    }
}

@Markup
@Composable
@Suppress("FunctionName")
fun CheckBoxCell(
    checked: Source<Boolean>,
    style: StyleScope.()->Unit = {},
    dataId: String? = null,
    onClick: () -> Unit = {}
){
    var checkedState by remember { mutableStateOf(checked.emit()) }
    CheckboxInput(checkedState,{
        if(dataId != null) dataId(dataId)
        style { style() }
        onClick { checkedState = !checkedState; onClick() }
    })
}
